var userSelfRegistrationCtrl = function (restSvc, ifacsSvc, $location, $scope, iFastWebContextRootSvc, iFastConstants, noCAPTCHA, $http, $window, $analytics) {

    "use strict";
    this.analytics = $analytics;
    this.setFlags(true);
    this.constants = iFastConstants;
    this.restSvc = restSvc;
    this.ifacsSvc = ifacsSvc;
    this.location = $location;
    this.scope = $scope;
    this.iFastWebContextRootSvc = iFastWebContextRootSvc;
    this.isLoaded = false;
    this.disableSubmit = false;
    this.isRecapSolved = false;
    this.showUserName = true;
    this.http = $http;
    this.window = $window;
    this.userType = "Advisor";
    this.showCaptcha = !(/MSIE [1-8]\./.test(this.window.navigator.userAgent));
    this.onLoad();
};


angular.module("iFAST.login")
    .directive("ngRecap", function () {
        "use strict";
        return {
            scope: {
                ngRecap: "=",
                ngRecapval: "="
            },
            link: function (scope) {
                scope.$watch("ngRecap", function (value) {
                    if (value) {
                        scope.$parent.$$childHead.control.isRecapSolved = true;
                    }
                });
            }
        };

    });

userSelfRegistrationCtrl.prototype.setFlags = function (flagStatus) {
    "use strict";
    this.isRegistrationPage = flagStatus;
    this.isAcceptableEmailAddress = flagStatus;
    this.isValidFullName = flagStatus;
    this.isValidPhone = flagStatus;
    this.isValidDealerOrBrokerCode = flagStatus;
    this.isValidRepCode = flagStatus;
    this.isValidEmail = flagStatus;
};

angular.module("iFAST.login")
    .directive("tooltip", function () {
        "use strict";
        return {
            restrict: "A",
            link: function (scope, element) {
                $(element).hover(function () {
                    $(element).tooltip("show");
                }, function () {
                    $(element).tooltip("hide");
                });
            }
        };
    });

userSelfRegistrationCtrl.prototype.setValid = function (field) {
    "use strict";
    switch (field) {
        case "fullName":
            this.isValidFullName = true;
            break;
        case "phone":
            this.isValidPhone = true;
            break;
        case "dealerOrBrokerCode":
            this.isValidDealerOrBrokerCode = true;
            break;
        case "repCode":
            this.isValidRepCode = true;
            break;
        case "email":
            this.isValidEmail = true;
            break;

    }

};

userSelfRegistrationCtrl.prototype.validateFormFields = function () {
    "use strict";
    var isFormDatValid = true;

    if (this.fullName === undefined || this.fullName.trim().length === 0) {
        this.isValidFullName = false;
        isFormDatValid = false;
    }

    if (this.phone === undefined || this.phone.trim().length === 0) {
        this.isValidPhone = false;
        isFormDatValid = false;
    }
    if (this.dealerOrBrokerCode === undefined || this.dealerOrBrokerCode.trim().length === 0) {
        this.isValidDealerOrBrokerCode = false;
        isFormDatValid = false;
    }
    if (this.repCode === undefined || this.repCode.trim().length === 0) {
        this.isValidRepCode = false;
        isFormDatValid = false;
    }

    if (this.email === null || this.email === undefined || this.email.trim().length === 0) {
        this.isValidEmail = false;
        isFormDatValid = false;
    }

    if (/MSIE [1-8]\./.test(this.window.navigator.userAgent)) {
        return isFormDatValid;
    }
    else {
        return isFormDatValid && this.isRecapSolved;
    }

};


userSelfRegistrationCtrl.prototype.getValidation = function () {
    "use strict";
    var ctrl = this;
    
    if (ctrl.UserSelfRegistrationSetting.UsernameVisible !== undefined && ctrl.UserSelfRegistrationSetting.UsernameVisible !== null) {
    	ctrl.showUserName = ctrl.UserSelfRegistrationSetting.UsernameVisible;
    }

    var messages = {
		fullNameEmpty: ctrl.UserSelfRegistrationSetting.fullNameRequired, //"Full name required",
        phoneEmpty: ctrl.UserSelfRegistrationSetting.phoneRequired, //"Phone required",
        dealerBrokerCodeEmpty: ctrl.UserSelfRegistrationSetting.dealerBrokerRequired, //"Dealer required",
        repCodeEmpty: ctrl.UserSelfRegistrationSetting.repCodeRequired, //"Rep Code Required",
        userName: "", //"User Name required",
        email: ctrl.UserSelfRegistrationSetting.emailRequired, //"Email required"
        recap: ctrl.UserSelfRegistrationSetting.recapCompletionRequired//ctrl.UserSelfRegistrationSetting.emailRequired //"Recaptcha completion is required"
    };

    var isErrorShown = function (ctrl) {
        return function () {
            if (ctrl && ctrl.validation && ctrl.onSubmitClicked) {
                return (!ctrl.validateFormFields());
            }
        };
    }(this);

    var validate = function (ctrl) {
        return function () {
            return ctrl.validation.validator.validate();
        };
    }(this);

    var isValid = true;

    return {
        messages: messages,
        isErrorShown: isErrorShown,
        isValid: isValid,
        validate: validate
    };
};

userSelfRegistrationCtrl.prototype.loadSelfRegistration = function () {
    "use strict";

    this.isRegistrationPage = true;
    this.isConfirmationPage = false;
    this.disableSubmit = false;
};


userSelfRegistrationCtrl.prototype.resetScreen = function () {
    "use strict";

    this.loadSelfRegistration();
    this.onSubmitClicked = false;


    this.fullName = "";
    this.phone = "";
    this.dealerOrBrokerCode = "";
    this.repCode = "";
    this.email = "";
    this.userName = "";
    this.comments = "";

    // reset recaptcha
    if (this.showCaptcha) {
        this.scope.$$childTail.$$childHead.control.reset();
        this.isRecapSolved = false;
    }
    // Reset
    this.setFlags(true);
};

userSelfRegistrationCtrl.prototype.loadSelfConfirmation = function () {
    "use strict";

    this.isRegistrationPage = false;
    this.isConfirmationPage = true;
};

userSelfRegistrationCtrl.prototype.onLoad = function () {
    "use strict";
    var ctrl = this;
    var clientCd = "";   
    
    
    if (location.hostname.indexOf("-") === -1) {
        clientCd = location.hostname.substr(0, location.hostname.indexOf("."));
    } else {
        clientCd = location.hostname.substr(0, location.hostname.indexOf("-"));
    }
    
    ctrl.clientCd = clientCd;
    var rest = this.restSvc.query({type: "configuration", method: "retrieveClientLoginSetting"}, {"clientCd": clientCd});
    rest.$promise.then(this.passClientLoginSetting(this), this.fail);
};

// Only following hosts e.g. {nxg/pmo/nce}, supports user registration.
userSelfRegistrationCtrl.prototype.isSelfRegistrationEnabled = function (controller) {
    "use strict";
    if (this.userAdminSettingMap.userSelfRegistrationLink !== undefined && this.userAdminSettingMap.userSelfRegistrationLink !== null) {
    	if (this.userAdminSettingMap.userSelfRegistrationLink.toUpperCase() === "TRUE") {       	
    		this.validateRegistration(controller);
        } else {
        	this.onCancel();
        }
    }
    else {
    		this.onCancel();
    }
};

userSelfRegistrationCtrl.prototype.validateRegistration = function (controller) {
    "use strict";
    var rest = this.restSvc.query({type: "configuration", method: "retrieveUserSelfRegistrationSetting"}, {"clientCd": controller.clientCd});
    var regSettingPromise = rest.$promise.then(this.passUserSelfRegistrationSetting(this), this.fail);
    regSettingPromise.then(function () {
    	controller.validation = controller.getValidation();
    	controller.emailValidationPattern = controller.createEmailValidationPattern(controller.UserSelfRegistrationSetting.userSelfRegistrationEmailBlackList);
    	controller.isLoaded = true;
    });   
};

userSelfRegistrationCtrl.prototype.createEmailValidationPattern = function (emailBlackStr) {
    "use strict";
    var emailBlackList = (emailBlackStr)? emailBlackStr.trim().split(","):"";
    var excludePattern = "";
    var i;
    for (i = 0; i < emailBlackList.length; i = i + 1) {
        excludePattern = excludePattern + "(?!" + emailBlackList[i] + "\\.)";
    }
    return new RegExp("([a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@" + excludePattern + "[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*)","i");
};

userSelfRegistrationCtrl.prototype.passClientLoginSetting = function (controller) {
    "use strict";
    return function (result) {    	
        controller.userAdminSettingMap = result.userAdminSettingMap;
        controller.language = result.userAdminSettingMap.language || navigator.language.substr(0, navigator.language.indexOf("-"));
        controller.isSelfRegistrationEnabled(controller);
    };
};

userSelfRegistrationCtrl.prototype.passUserSelfRegistrationSetting = function (controller) {
    "use strict";
    return function (result) {
        controller.UserSelfRegistrationSetting = result.userSelfRegistrationSettingMap;
    };

};

/* Send the request to ESB for userSelfRegistration with form data */
userSelfRegistrationCtrl.prototype.onSubmit = function () {
    "use strict";

    // analytics
    // track analytics
    this.analytics.eventTrack("UserSelfRegister",
        {"fullNameValue": this.fullName,
            "fullnameText": this.fullName,
            "fullnameFieldName": "userSelfRegistrationNameFld",
            "fullnameObjectName": "UserSelfRegistrationSetting",
            "phoneValue": this.phone,
            "phoneText": this.phone,
            "phoneFieldName": "userSelfRegistrationPhoneFld",
            "phoneObjectName": "UserSelfRegistrationSetting",
            "dealerOrBrokerCodeValue": this.dealerOrBrokerCode,
            "dealerOrBrokerCodeText": this.dealerOrBrokerCode,
            "dealerOrBrokerCodeFieldName": "userSelfRegistrationDealerOrBrokerCodeFld",
            "dealerOrBrokerCodeObjectName": "UserSelfRegistrationSetting",
            "repCodeValue": this.repCode,
            "repCodeText": this.repCode,
            "repCodeFieldName": "userSelfRegistrationRepCodeFld",
            "repCodeObjectName": "UserSelfRegistrationSetting",
            "userNameValue": this.userName,
            "userNameText": this.userName,
            "userNameFieldName": "userSelfRegistrationDesiredUserNameFld",
            "userNameObjectName": "UserSelfRegistrationSetting",
            "emailValue": this.email,
            "emailText": this.email,
            "emailFieldName": "userSelfRegistrationEmailFld",
            "emailObjectName": "UserSelfRegistrationSetting",
            "commentsValue": this.comments,
            "commentsText": this.comments,
            "commentsFieldName": "userSelfRegistrationCommentsFld",
            "commentsObjectName": "UserSelfRegistrationSetting",
            "module": "Prelogin",
            "submodule": "UserSelfRegistrationSetting"});

    this.onSubmitClicked = true;

    if (!this.validateFormFields()) {
        this.loadSelfRegistration();
        return false;
    }

    var langCd = navigator.language || navigator.userLanguage;
    langCd = langCd.substr(0, langCd.indexOf("-"));

    this.disableSubmit = true;

    if (this.userAdminSettingMap.clientVersion !== null && this.userAdminSettingMap.clientVersion !== undefined &&
        this.userAdminSettingMap.clientVersion.toUpperCase() !== "REMOTE") {
        this.ifacsSvc.userSelfRegistration({ method: "user_registration"},
            {
                "full_name": this.fullName,
                "language": langCd,
                "phone": this.phone,
                "dealer_broker_code": this.dealerOrBrokerCode,
                "rep_code": this.repCode,
                "j_username": this.userName,
                "email": this.email,
                "comments": this.comments,
                "client_code": this.iFastWebContextRootSvc.clientCode,
                "client_version": this.userAdminSettingMap.clientVersion,
                "user_type": this.userType 
            }).$promise.then(this.success(this));
    }
    else {
        this.ifacsSvc.userSelfRegistration({ method: "user_registration"},
            {
                "full_name": this.fullName,
                "language": langCd,
                "phone": this.phone,
                "dealer_broker_code": this.dealerOrBrokerCode,
                "rep_code": this.repCode,
                "j_username": this.userName,
                "email": this.email,
                "comments": this.comments,
                "client_code": this.iFastWebContextRootSvc.clientCode,
                "user_type": this.userType 
            }).$promise.then(this.success(this));
    }
};

/*
 * Stay in the information page if not successful otherwise display confirmation
 * page
 */
userSelfRegistrationCtrl.prototype.success = function (controller) {
    "use strict";

    return function (response) {
        window.console.log("User Self Registration request is submitted.");
        var responseCode = response.code;
        window.console.log("Response from ifacs:" + responseCode);
        if ("SUCCESS" === responseCode) {
            controller.loadSelfConfirmation();
        } else {
            controller.loadSelfRegistration();
        }
    };

};


userSelfRegistrationCtrl.prototype.register = function () {
    "use strict";
/*    if ($scope.selfRegistration1.$valid) {
        $scope.showdialog = true;
        window.console.log("Form is valid");
    }*/

    //TODO evaluate if this function is needed.
};


/* Call back the login page upon cancel */
userSelfRegistrationCtrl.prototype.onCancel = function () {
    "use strict";
    "use strict";
  var url=window.location.href;
  var ifstwbprinUrlIndex=url.indexOf('ifastweb');  
  var secondPart,firstPart,redirectUrl;
  if(ifstwbprinUrlIndex > 0){
    secondPart= "ifastweb/login.html#!/login";
	firstPart= url.substring(0,url.indexOf("ifastweb"));
	redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }else{
    secondPart= "/login.html#!/login";
	firstPart= url.substring(0,url.indexOf("/login.html"));
	redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }

};

userSelfRegistrationCtrl.$inject = ["restSvc", "ifacsSvc", "$location", "$scope", "iFastWebContextRootSvc", "iFastConstants", "noCAPTCHA", "$http", "$window", "$analytics"];

angular.module("iFAST.login")
    .controller("userSelfRegistrationCtrl", userSelfRegistrationCtrl)
    .config(["noCAPTCHAProvider", function (noCaptchaProvider) {
        "use strict";
        noCaptchaProvider.setSiteKey("6LdSzf4SAAAAAP8IbU-e3uu3HvkZHsY9X7-mmT5J");
        noCaptchaProvider.setTheme("dark");

    }]);




// WEBPACK FOOTER //
// ./WebContent/src/login/userSelfRegistration-controller.js